import { useTranslation } from "react-i18next";

import { Stack } from "@mui/material";

import { FormDialog } from "../../../../../../form-dialog/FormDialog";
import { DependantFormValue } from "../../RelativesView.types";
import { DependantFields } from "../dependant-fields/DependantFields";
import { useAddDependant } from "./hooks/useAddDependant";

interface Props {
  onClose: () => void;
  onAdd: (dependant: DependantFormValue) => void;
}

export function AddDependantDialog({ onClose, onAdd }: Props) {
  const { t } = useTranslation();
  const { formik } = useAddDependant(onAdd, onClose);
  const section = "clients.client.debtSettlement.assetInventory.dependants";

  return (
    <FormDialog
      title={t(`${section}.addDialogTitle`)}
      onClose={onClose}
      formik={formik}
      submitLabel={t(`${section}.addDialogSubmit`)}
      paperSx={{ width: 1100 }}
    >
      <Stack gap={2} pt={1}>
        <DependantFields formik={formik} dependant={formik.values} />
      </Stack>
    </FormDialog>
  );
}
